import Vue from 'vue';
import VueGtm from 'vue-gtm';

function addGtm(id) {
  Vue.use(VueGtm, {
    id,
    debug: false,
  });
}

export default {
  addGtm,
};
